import { PlusIcon, WaitlistIcon } from "@xola/icons";
import clsx from "clsx";
import { getDraftReasons, isPast } from "common";
import { isDraft } from "immer";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Timeslot } from "types";
import shallow from "zustand/shallow";
import { SecondaryButton } from "../Common/SecondaryButton";
import { JoinWaitlistModal } from "../Event/JoinWaitlistModal";
import { useExperience } from "@/hooks/resources/useProduct";
import { makeExperiencePurchaseItem } from "@/models/CreatePurchaseState";
import { CreatePurchaseStep, useCreatePurchaseStore } from "@/stores/createPurchaseStore";
import { useDashboardFilterStore } from "@/stores/dashboardFilterStore";
import { DashboardMode } from "@/types/Dashboard";

export const CreatePurchaseButton = ({ timeslot }: { timeslot: Timeslot }) => {
    const history = useHistory();
    const { data: experience } = useExperience(timeslot.product);
    const [addItem, resetState] = useCreatePurchaseStore(
        (state) => [state.actions.addItem, state.actions.resetState],
        shallow,
    );
    const setSeller = useCreatePurchaseStore((state) => state.actions.setSeller);

    const [showWaitlistModal, setShowWaitlistModal] = useState(false);

    const { canWaitlist, canBook } = timeslot;
    const isWaitlistDisabled = !canWaitlist || isPast(timeslot.arrivalDatetime);

    const mode = useDashboardFilterStore((state) => state.filters.mode);
    const isListMode = mode === DashboardMode.LIST;

    const draftReasons = experience ? getDraftReasons(experience) : [];
    const isDraftExperience = isDraft(experience) || draftReasons.length > 0;
    const isDisabled = (!canBook && isWaitlistDisabled) || isDraftExperience;

    const handleBook = (e: any) => {
        e.stopPropagation();

        if (canWaitlist) {
            setShowWaitlistModal(true);
        } else {
            const arrival = { date: timeslot.date, time: timeslot.time };
            if (experience) {
                // reset it first to clear any leftover
                resetState();
                setSeller(experience.seller.id);
                addItem(makeExperiencePurchaseItem(experience, arrival, timeslot));
                useCreatePurchaseStore.setState({ step: CreatePurchaseStep.CHECKOUT });
                history.push("/cart");
            }
        }
    };

    return (
        <>
            <SecondaryButton
                size={isListMode ? "small" : "tiny"}
                color={canWaitlist ? "caution" : canBook && !isDraftExperience ? "success" : "secondary"}
                disabled={isDisabled}
                className={clsx(isDisabled && "!cursor-not-allowed")}
                data-testid="dashboard-create-purchase-button"
                onClick={handleBook}
            >
                {canWaitlist ? <WaitlistIcon /> : <PlusIcon />}
            </SecondaryButton>

            <JoinWaitlistModal
                isOpen={showWaitlistModal}
                timeslot={timeslot}
                onClose={() => setShowWaitlistModal(false)}
            />
        </>
    );
};
